<template>
  <div>
    <nx-chip v-if="type" dark default class="hidden-sm-and-down">
      {{ $tc(`message.content.type.${type}`) }}
    </nx-chip>

    <nx-chip dark default class="hidden-sm-and-down"
             @click.capture.stop="copyUrl">
      ID: {{ id }}
    </nx-chip>

    <nx-chip v-if="relativeVersionId" class="hidden-sm-and-down" dark default>
      Version: {{ relativeVersionId }}
    </nx-chip>

    <slot/>

    <v-tooltip v-if="isScheduled" bottom>
      <template #activator="{on}">
        <nx-chip class="hidden-sm-and-down" dark alert>
          <template v-if="schedulePublishDate">
            {{ $t('message.metadata.schedulePublish') }} {{ schedulePublishDate | formatDate }}
          </template>
          <template v-else>
            {{ $t('message.metadata.scheduled') }}
          </template>
        </nx-chip>
      </template>
    </v-tooltip>

    <nx-chip v-if="entityPublishedVersionStartPublicationDate" class="hidden-sm-and-down" dark success>
      {{ $t('message.metadata.contentHeaderPublishedDate') }}
      {{ entityPublishedVersionStartPublicationDate | formatDate }}
    </nx-chip>

    <nx-chip v-if="unpublishedDate && !isPublished" dark alert class="hidden-sm-and-down">
      {{ $t('message.metadata.unpublishedDate') }} {{ unpublishedDate | formatDate }}
    </nx-chip>

    <v-tooltip v-if="scheduleUnpublishDate" bottom>
      <template #activator="{on}">
        <nx-chip class="hidden-sm-and-down" dark alert>
          {{ $t('message.metadata.scheduleUnpublish') }} {{ scheduleUnpublishDate | formatDate }}
        </nx-chip>
      </template>
    </v-tooltip>

    <nx-chip v-if="!isPublished && hasRedirection" class="hidden-sm-and-down" dark default>
      {{ $t('message.metadata.hasRedirection') }}
    </nx-chip>

    <v-tooltip bottom class="hidden-sm-and-down" v-if="stateVersionText">
      <nx-chip slot="activator" dark :success="isPublished" :alert="!isPublished">
        {{ stateVersionText }}
      </nx-chip>
      <span v-html="$t('message.metadata.stateVersion')"></span>
    </v-tooltip>
  </div>
</template>

<script>
import NxChip from '@/components/chips/Chip';
import { copyToClipboard } from '@/utils';

export default {
  name: 'nx-versionable-content-editor-header-common-chips',
  components: { NxChip },
  props: {
    type: String,
    entityPublishedVersionStartPublicationDate: String,
    entityScheduled: Boolean,
    isDraft: Boolean,
    isScheduled: Boolean,
    isPublished: Boolean,
    id: Number,
    relativeVersionId: Number,
    hasBeenPublished: Boolean,
    hasRedirection: Boolean,
    schedulePublishDate: String,
    scheduleUnpublishDate: String,
    unpublishedDate: String,
  },
  computed: {
    stateVersionText() {
      if (this.isPublished) {
        return this.$t('message.metadata.state.published');
      }
      if (this.hasBeenPublished) {
        return this.$t('message.metadata.state.hasBeenPublished');
      }
      if (this.isDraft) {
        return this.$t('message.metadata.state.draft');
      }
      return null;
    },
    urlWithOutVersionId() {
      const url = window.location.href;
      return url.replace(`/${this.$route.params.relativeVersionId}`, '');
    },
  },
  methods: {
    async copyUrl(event) {
      event.stopPropagation();
      event.preventDefault();
      const copyText = this.$store.getters.features.COPY_CONTENT_URL_WITHOUT_VERSION_ID
        ? this.urlWithOutVersionId
        : this.id;
      await copyToClipboard(copyText);
      this.toast.notify('message.list.actions.clipboardCopy');
    },
  },
};
</script>
